<app-main-layout *ngIf="isAuthenticated$ | async; else showAuth"></app-main-layout>
<ng-template #showAuth>
  <router-outlet></router-outlet>
</ng-template>
<app-toast></app-toast>
